export const ServicePartnerEndpoint = {
  SERVICE_PARTNER_LOAD: '/default/service-partner/load',
  SERVICE_PARTNER_CREATE: '/default/service-partner/create',
  SERVICE_PARTNER_UPDATE: '/default/service-partner/update',
  SERVICE_PARTNER_DELETE: '/default/service-partner/delete',
};
